import React from "react";
import Navbar from "../navbar/Navbar";
import ContactusVideo from "../../../Assets/ContactusPage.mp4";
import ContactusThumbnail from "../../../Assets/ContactusPageThumbnail.png";
import Dialer from "../../../Assets/dialer.png";
import Mail from "../../../Assets/mail.png";
import YouTube from "../../../Assets/Youtube.png";
import Facebook from "../../../Assets/Facebook.png";
import Linkedin from "../../../Assets/Linkedin.png";
import QRCode from "../../../Assets/Puphub_QR_Code.png";
import googleplay from "../../../Assets/google-play.svg";
import Instagram from "../../../Assets/insta.png";
import Footer from "../../footer/Footer";
import { Helmet } from "react-helmet-async";

interface SocialMediaLink {
  url: string;
  icon: string;
  alt: string;
  className?: string;
}

const ContactusPage: React.FC = () => {
  const socialMediaLinks: SocialMediaLink[] = [
    {
      url: "https://youtube.com/@puphub24",
      icon: YouTube,
      alt: "YouTube",
      className: "h-12"
    },
    {
      url: "https://www.facebook.com/profile.php?id=61560652664233",
      icon: Facebook,
      alt: "Facebook",
      className: "h-12"
    },
    {
      url: "https://www.instagram.com/2024puphub?igsh=Mjl2cXM3aDBpdzEw",
      icon: Instagram,
      alt: "Instagram",
      className: "h-14"
    },
    {
      url: "https://www.linkedin.com/company/103064496/admin/dashboard/",
      icon: Linkedin,
      alt: "LinkedIn",
      className: "h-12"
    }
  ];

  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://puphub.co.in/contactus" />
        <title>PupHub | Contact Us</title>
        <meta
          name="description"
          content="Get in touch with the PupHub team. We're here to help you and your pets."
        />
      </Helmet>
      
      <Navbar />
      
      <div>
        <video
          className="w-[100vw] h-[50vh] sm:h-[70vh] object-fill"
          src="https://puphub-customer.s3.ap-south-1.amazonaws.com/static_data/videos/ContactusPage.mp4"
          autoPlay
          loop
          muted
          playsInline
          poster="https://puphub-customer.s3.ap-south-1.amazonaws.com/static_data/images/ContactusPageThumbnail.png"
          aria-label="PupHub contact information video"
        />
      </div>
      
      <div>
        {/* Contact Information */}
        <section className="grid grid-cols-1 lg:grid-cols-3 gap-8 p-10 text-white">
          {/* Get in Touch Section */}
          <div className="text-center lg:text-left">
            <h2 className="text-2xl font-bold mb-4">Get in Touch</h2>
            <p className="text-lg">Phone Number</p>
            <a href="tel:+918918080399" aria-label="Call PupHub">
              <img
                className="inline-block w-8 h-8 m-1 transform hover:scale-110 active:scale-90 transition-transform duration-200"
                src={Dialer}
                alt="Phone icon"
              />
            </a>
            +91 8918080399
            <p className="text-lg">Email Address</p>
            <a href="mailto:apexiumtechnologies@gmail.com" aria-label="Email PupHub">
              <img
                className="inline-block w-8 h-8 m-1 transform hover:scale-110 active:scale-90 transition-transform duration-200"
                src={Mail}
                alt="Email icon"
              />
            </a>
            apexiumtechnologies@gmail.com
          </div>

          {/* Address Section */}
          <div className="text-center lg:text-left">
            <h2 className="text-2xl font-bold mb-4">Where we are</h2>
            <p className="text-lg">Address</p>
            <p className="mb-2">
              1ST FLOOR, BE 125, AA-1, ST NO 163 &amp; 174, New Town, Kolkata,
              West Bengal, Pin-700156.
            </p>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3683.9393517362187!2d88.46856207475739!3d22.581371532649854!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a027500758a8955%3A0xdf27b61f3189d55f!2sApexium%20Technologies%20Private%20Limited!5e0!3m2!1sen!2sin!4v1727783316967!5m2!1sen!2sin"
              title="Apexium Technologies Location"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="mb-10 sm:w-4/5 h-3/5"
              aria-label="Google Maps location of Apexium Technologies"
            />
          </div>

          {/* Social Media Section */}
          <div className="text-center lg:text-left">
            <h2 className="text-2xl font-bold mb-4">
              Follow us on Social Media
            </h2>
            <div className="flex justify-center lg:justify-start space-x-10 sm:space-x-20">
              {socialMediaLinks.map((link, index) => (
                <a 
                  key={`social-link-${index}`}
                  href={link.url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label={`PupHub on ${link.alt}`}
                >
                  <img 
                    src={link.icon} 
                    alt={link.alt} 
                    className={link.className} 
                  />
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* QR Code Section */}
        <section className="hidden sm:flex text-center py-16">
          <div className="flex items-center justify-center">
            <img 
              src={QRCode} 
              alt="PupHub App QR Code" 
              className="h-40 w-40 ml-10" 
            />
            <p className="text-2xl font-bold text-white m-10">
              Scan to Download the App
            </p>
          </div>
        </section>
        
        {/* Playstore Link */}
        <section className="sm:hidden">
          <div className="flex justify-center items-center space-x-5">
            <a
              href="https://play.google.com/store/apps/details?id=com.puphub"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Download PupHub on Google Play"
            >
              <img 
                src={googleplay} 
                alt="Google Play Store" 
                className="h-10 w-10" 
              />
            </a>
            <p className="text-sm font-bold text-white">
              Download Android App here
            </p>
          </div>
        </section>
      </div>
      
      <Footer />
    </>
  );
};

export default ContactusPage;